import { graphql } from "../../gql/index.ts";
import { useQuery } from "@apollo/client";

export const GetMyRemainingLessons = graphql(`
  query getMyRemainingLessons {
    getMyRemainingLessons {
      remainingLessons
      totalAvailableLessons
      planEndDate
    }
  }
`);

export function useMyRemainingLessons() {
  const { data, loading } = useQuery(GetMyRemainingLessons);
  return {
    remainingLessons: data?.getMyRemainingLessons.remainingLessons ?? 0,
    totalAvailableLessons:
      data?.getMyRemainingLessons.totalAvailableLessons ?? 0,
    planEndDate: data?.getMyRemainingLessons.planEndDate ?? null,
    loading,
  };
}
